import { ReactNode } from 'react';
import { Button, Dialog, Modal, Text } from '@oliasoft-open-source/react-ui-library';

type MoveFileDialogProps = {
  heading: string;
  message: ReactNode;
  actions: { label: string; colored?: boolean | string; onClick: () => void }[];
  onClose: () => void;
};

export const MoveFileDialog = ({
  heading, message, actions, onClose,
}: MoveFileDialogProps) => {
  return (
    <Modal visible centered onEscape={onClose}>
      <Dialog
        dialog={{
          heading,
          width: '320px',
          content: <Text>{message}</Text>,
          footer: (
            <>
              {actions.map((action) => (
                <Button key={action.label} colored={action.colored} label={action.label} onClick={action.onClick} />
              ))}
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};
